import { Link } from "react-router-dom"
import { ChevronRight, Wrench, Car, Heart, Building, Cog, Bike } from "lucide-react"
import "./Hose.css"

const HosesPage = () => {
  const hosesCategories = {
    "Assembly & Solution For Vehicle": [
      { name: "Tata", path: "/automobile-products" },
      { name: "Leyland", path: "/automobile-products" },
      { name: "Mahindra", path: "/automobile-products" },
      { name: "Eicher", path: "/automobile-products" },
      { name: "Man", path: "/automobile-products" },
      { name: "Mercedes", path: "/automobile-products" },
      { name: "Volvo", path: "/automobile-products" },
      { name: "Scania", path: "/automobile-products" },
      { name: "Renault", path: "/automobile-products" },
      { name: "Volvo", path: "/automobile-products" },
      { name: "Volkswagen", path: "/automobile-products" },
      { name: "Ford", path: "/automobile-products" },
      { name: "Toyota", path: "/automobile-products" },
      { name: "Iveco", path: "/automobile-productss" },
      { name: "DAF", path: "/automobile-products" },
      { name: "BMC", path: "/automobile-products" },
      { name: "Mitsubishi Otobus", path: "/automobile-products" }
    ],
    "Hoses & Tubes for Automobile": [
      { name: "General Purpose Hoses Coolant / Air / Fuel ", path: "/products/753383" },
      { name: "Hoses for Engine Oil ", path: "/products/1A9017" },
      { name: "Temperature Hoses ", path: "/products/4B1B48" },
      { name: "Air Brake Nylone Tube", path: "/products/D80250" },
      { name: "TPU tubes", path: "/products/0617B9" },
      { name: "LD tube ", path: "/products/AAAAF8" },
      { name: "PVC Linning tubes", path: "/products/B309C2" },
      { name: "Low pressure flexible wire braided ", path: "/products/B1EA75" }
    ],
    "Hoses for Medical Line": [
      { name: "Anti static Hose", path: "/products/6D6461" },
      { name: "High Pressure Oxygen Tube", path: "/products/ED0A70" },
      { name: "Transparent PVC tube ", path: "/products/AEDDE5" },
      { name: "Oxygen Hoses", path: "/products/EA8CD8" }
    ],
    "Hoses for Construction": [
      { name: "Water levelling PVC tube", path: "/products/17D599" },
      { name: "Garden Hose", path: "/products/E81D95" },
      { name: "High pressure water tube ", path: "/products/180EB1" },
      { name: "Rubber Hoses", path: "/products/D80089" },
      { name: "Washing Hoses", path: "/products/B97C17" },
      { name: "Spray Paint Hoses", path: "/products/743C3E" }
    ],
    "Hoses for Hardware & Industry": [
      { name: "TPU Coil", path: "/products/EA8E01" },
      { name: "TPU Rolls", path: "/products/3D4257" },
      { name: "Spray Hoses", path: "/products/D51AE8" },
      { name: "Temperature Hoses", path: "/products/4B1B48" },
      { name: "General Purpose Hoses Coolant / Air / Fuel", path: "/products/753383" },
      { name: "Cutting Oil Hoses", path: "/products/CF0F7A" },
      { name: "Welding Hose", path: "/products/F7DE3E" },
      { name: "Hydraulic Hose", path: "/products/78A9A5" },
      { name: "Low Pressure Hoses", path: "/products/9F317C" },
      { name: "Nylon High Temperature Tube", path: "/products/09506E" },
      { name: "Greese Gun Hoses", path: "/products/E8287F" }
    ],
    "TWO WHEELER SEGMENT": [
      { name: "Hydraulic Brake Hose", path: "/products/433CF3" },
      { name: "Side Guard", path: "/products/64F051" },
      { name: "Fuel Hose", path: "/products/EC62DC" },
    ],
  }

  const getCategoryIcon = (categoryName) => {
    switch (categoryName) {
      case "Assembly & Solution For Vehicle":
        return <Car className="category-icon" />
      case "Hoses & Tubes for Automobile":
        return <Wrench className="category-icon" />
      case "Hoses for Medical Line":
        return <Heart className="category-icon" />
      case "Hoses for Construction":
        return <Building className="category-icon" />
      case "Hoses for Hardware & Industry":
        return <Cog className="category-icon" />
      case "TWO WHEELER SEGMENT":
        return <Bike className="category-icon" />
      default:
        return <Wrench className="category-icon" />
    }
  }

  const getCategoryColor = (index) => {
    const colors = [
      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
    ]
    return colors[index % colors.length]
  }

  return (
    <div className="hoses-page">
      {/* Hero Section */}
      <div className="hoses-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Our Hoses & Solutions</h1>
            <p className="hero-subtitle">
              Comprehensive range of high-quality hoses and tubes for various industries and applications
            </p>
          </div>
        </div>
      </div>

      {/* Categories Section */}
      <div className="hoses-categories">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Product Categories</h2>
            <p className="section-subtitle">
              Explore our comprehensive range of hoses and solutions tailored for different industries
            </p>
          </div>

          <div className="categories-grid">
            {Object.entries(hosesCategories).map(([categoryName, items], index) => (
              <div key={index} className="category-card">
                <div className="category-header" style={{ background: getCategoryColor(index) }}>
                  <div className="category-icon-wrapper">{getCategoryIcon(categoryName)}</div>
                  <h3 className="category-title">{categoryName}</h3>
                  <div className="category-count">{items.length} Products</div>
                </div>

                <div className="category-content">
                  <div className="products-grid">
                    {items.map((item, itemIndex) => (
                      <Link key={itemIndex} to={item.path} className="product-item">
                        <div className="product-content">
                          <span className="product-name">{item.name}</span>
                          <ChevronRight className="product-arrow" />
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                {/* <div className="category-footer">
                  <Link to={`/category/${categoryName.toLowerCase().replace(/\s+/g, "-")}`} className="view-all-btn">
                    View All Products
                    <ChevronRight className="btn-arrow" />
                  </Link>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="hoses-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Need Custom Solutions?</h2>
            <p className="cta-subtitle">
              Our team of experts can help you find the perfect hose solution for your specific requirements
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="cta-btn primary">
                Get Quote
              </Link>
              <Link to="/products" className="cta-btn secondary">
                Browse All Products
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HosesPage
